module.exports = __webpack_public_path__ + "static/media/ic-search.cce9903a.svg";